
    import * as React from 'react';

    const Shipping24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M8 17a2 2 0 11-4 0H2V5h13v2h4.456L22 11.91V17h-2a2 2 0 11-4 0H8zm-.268-1H14V6H3v10h1.268a2 2 0 013.464 0zM15 8v8h1.268a2 2 0 013.464 0H21v-3h-4V9h2.366l-.518-1H15zm3 2v2h2.905l-1.033-2H18zm0 8a1 1 0 100-2 1 1 0 000 2zM6 18a1 1 0 100-2 1 1 0 000 2z" /></svg>
        </div>
      );
    };

    Shipping24.displayName = 'Shipping24';

    export default Shipping24;
  